// Admin User Creation Utility
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { auth, db } from '../services/firebase';

// Default admin credentials
export const ADMIN_CREDENTIALS = {
  email: 'admin@giftedsolutions.com',
  password: 'GiftedAdmin2024!',
  displayName: 'Gifted Solutions Admin'
};

/**
 * Create admin user with predefined credentials
 */
export const createAdminUser = async () => {
  try {
    console.log('🔥 Creating admin user...');
    
    // Create user with Firebase Auth
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      ADMIN_CREDENTIALS.email,
      ADMIN_CREDENTIALS.password
    );
    
    const user = userCredential.user;
    console.log('✅ Admin user created in Firebase Auth:', user.uid);
    
    // Create admin profile in Firestore
    const adminProfile = {
      uid: user.uid,
      email: user.email,
      displayName: ADMIN_CREDENTIALS.displayName,
      role: 'admin',
      isAdmin: true,
      createdAt: new Date().toISOString(),
      permissions: ['read', 'write', 'delete', 'admin'],
      createdBy: 'system'
    };
    
    await setDoc(doc(db, 'users', user.uid), adminProfile);
    console.log('✅ Admin profile created in Firestore');
    
    return {
      success: true,
      user: adminProfile,
      credentials: {
        email: ADMIN_CREDENTIALS.email,
        password: ADMIN_CREDENTIALS.password
      }
    };
    
  } catch (error) {
    console.error('❌ Error creating admin user:', error);
    
    if (error.code === 'auth/email-already-in-use') {
      return {
        success: false,
        error: 'Admin user already exists',
        credentials: {
          email: ADMIN_CREDENTIALS.email,
          password: ADMIN_CREDENTIALS.password
        }
      };
    }
    
    throw error;
  }
};

/**
 * Quick admin setup function
 */
export const setupAdmin = async () => {
  try {
    const result = await createAdminUser();
    
    if (result.success) {
      console.log('🎉 Admin setup complete!');
      console.log('📧 Email:', result.credentials.email);
      console.log('🔑 Password:', result.credentials.password);
      console.log('🔗 Admin Dashboard: /admin-dashboard');
    } else {
      console.log('ℹ️ Admin user already exists');
      console.log('📧 Email:', result.credentials.email);
      console.log('🔑 Password:', result.credentials.password);
      console.log('🔗 Admin Dashboard: /admin-dashboard');
    }
    
    return result;
  } catch (error) {
    console.error('❌ Admin setup failed:', error);
    throw error;
  }
};

// Auto-run admin setup in development
if (import.meta.env.DEV) {
  console.log('🚀 Development mode detected - Admin credentials available:');
  console.log('📧 Email:', ADMIN_CREDENTIALS.email);
  console.log('🔑 Password:', ADMIN_CREDENTIALS.password);
  console.log('🔗 Login at: /login');
  console.log('🔗 Admin Dashboard: /admin-dashboard');
}
